import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';
import { breakpoints } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  header: {
    position: 'relative',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '5.6rem auto 5.2rem',
    maxWidth: '109.6rem',
    '@media(max-width: 840px)': {
      paddingTop: '4rem',
    },
  },
  title: {
    margin: '0 0 0.8rem',
    fontSize: '3.4rem',
    lineHeight: '4rem',
    letterSpacing: '0.02rem',

    '@media(max-width: 840px)': {
      fontSize: '2.8rem',
      lineHeight: '4rem',
    },
  },
  caption: {
    margin: { bottom: '1.2rem' },
    font: { size: '1.8rem', lineHeight: '2.8rem' },
    letterSpacing: '0.02rem',
  },
  playTutorialButton: { textTransform: 'uppercase' },
  playTutorialLink: {
    textDecoration: 'none',
  },
  backButton: {
    position: 'absolute',
    left: 0,
    top: '2.6rem',
    paddingLeft: 0,
    '@media(max-width: 840px)': {
      top: '6rem',
    },
    [breakpoints.md.down]: {
      top: '-1rem',
    },
  },
  backButtonInLine: {
    top: '0.7rem',
    '@media(max-width: 840px)': {
      top: '5rem',
    },
    [breakpoints.md.down]: {
      top: '0.7rem',
    },
  },
  bcBlock: {
    backgroundColor: colors.neutral.white,
    marginBottom: '2.8rem',
    marginTop: '2.8rem',
    textAlign: 'center',
    maxWidth: '70%',
    '@media(max-width: 424px)': {
      borderRadius: '5rem',
      maxWidth: '24rem',
    },
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
